/**
 * Enum for the input mode (hours or minutes).
 */
export var TimePickerInputModeEnum;
(function (TimePickerInputModeEnum) {
    TimePickerInputModeEnum["HOURS"] = "hours";
    TimePickerInputModeEnum["MINUTES"] = "minutes";
})(TimePickerInputModeEnum || (TimePickerInputModeEnum = {}));
